module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-55.247e769.woff2";